import Vue from 'vue'
import {
  Toast,
  Dialog,
  ActionSheet,
  Swipe,
  SwipeItem,
  List,
  PullRefresh,
  Popup,
  Icon,
  Area,
  Loading,
  Switch
} from 'vant'

Vue.use(Toast)
Vue.use(Dialog)
Vue.use(ActionSheet)
Vue.use(List)
Vue.use(PullRefresh)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Popup)
Vue.use(Icon)
Vue.use(Area)
Vue.use(Loading)
Vue.use(Switch)
